<template>
  <PreviewLayout :item="item" :loading="loading">
    <div class="p-postEditor__image">
      <v-row>
        <v-col lg="7">
          <v-img :src="imageSrc" class="lighten-2" max-height="300" contain>
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular indeterminate color="grey lighten-5" />
              </v-row>
            </template>
          </v-img>
          <div v-if="quoteUrl" class="caption ma-1">
            引用元:
            <a
              class="d-inline"
              :href="quoteUrl"
              rel="noopener noreferrer"
              target="_blank"
            >
              {{ quoteUrl }}
            </a>
          </div>
        </v-col>
        <v-col lg="5">
          <h3
            v-if="heading"
            class="p-postEditor__heading3"
            v-html="previewHeadingItem()"
          ></h3>
          <p
            v-if="content"
            class="p-postEditor__text"
            v-html="previewContentItem()"
          ></p>
        </v-col>
      </v-row>
    </div>
  </PreviewLayout>
</template>

<script>
import baseTextlintPreview from '@/mixins/base_textlint_preview'
import PreviewLayout from './PreviewLayout'

export default {
  name: 'ImageItemPreview',
  components: { PreviewLayout },
  mixins: [baseTextlintPreview],
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      headingLintTag: this.textLintAllowTagFormat('heading'),
      contentLintTag: this.textLintAllowTagFormat('content')
    }
  },
  computed: {
    quoteUrl: function () {
      return this.item.itemableAttributes.quoteUrl
    },
    heading: function () {
      return this.item.itemableAttributes.heading
    },
    content: function () {
      return this.item.itemableAttributes.content
    },
    lintContent: function () {
      return `${this.headingLintTag[0]}${this.heading}${this.headingLintTag[1]}\n${this.contentLintTag[0]}${this.content}${this.contentLintTag[1]}`
    },
    imageSrc: function () {
      if (this.item.itemableAttributes.imageDirectUrl) {
        return this.item.itemableAttributes.imageDirectUrl
      } else {
        return this.item.itemableAttributes.imagableUrl
      }
    }
  },
  mounted () {
    this.setLintAction(this.lintContent)

    this.$store.subscribe((mutation) => {
      if (mutation.type === 'PostEditor/UPDATE_ITEM') {
        if (mutation.payload.uuid === this.item.uuid) {
          this.setLintAction(this.lintContent)
          this.$store.commit('TextLintStore/deleteItemLintResult', {
            uuid: this.uuid
          })
          this.lintAction().call()
        }
      }
    })
  },
  methods: {
    previewHeadingItem () {
      return this.parseLintContent(this.headingLintTag) || this.heading
    },
    previewContentItem () {
      return this.parseLintContent(this.contentLintTag) || this.content
    },
    parseLintContent (tag) {
      const previewContentText = this.previewContent(this.lintContent)
      const re = new RegExp(`${tag[0]}[\\s\\S]*${tag[1]}`, 'g')

      if (previewContentText.match(re)) {
        return previewContentText
          .match(re)
          .pop()
          .replace(tag[0], '')
          .replace(tag[1], '')
      }
    }
  }
}
</script>
